<div class="block" [ngClass]="{'mt-0': margin0Input, 'mt-2': !margin0Input, 'mb-2': margin0Input ,'mb-0': margin0BottomInput}">
    <label [ngClass]="getLabelClass()">
        {{labelText}}
        <ng-container *ngIf="isRequired">
            <span class="star">*</span>
        </ng-container>
    </label>
    <div [ngClass]="getDivClass()">
        <ng-content></ng-content>
    </div>
</div>